import window from 'window-or-global';

export function inlineTasks() {
	/**
	 * CONFDEV-55089
	 * When opening comment editor, AJS.Meta.set() is invoke
	 * which set value to a variable inside module 'confluence/meta' without updating meta tag in DOM
	 * So we need to use AJS.Meta.get() to retrieve correct meta value
	 */
	const useInlineTasks = window.AJS.Meta.get('use-inline-tasks');
	return useInlineTasks === 'true' || useInlineTasks === true;
}
